<script>
   import { createEventDispatcher } from 'svelte';
   const dispatch = createEventDispatcher();
  function sos() {
    // alert("SOS");
    dispatch("sosevent", {
      item: "user clicked sos button"
    });
  }
</script>

<button type="button" on:click={sos} class="button sos"><span class="icon fa-solid fa-bell"></span><span class="text">SOS</span></button>
